import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IUserAccessor2r676j1t9f9ew as IUserAccessor,
  IPlatformUserProvidernolzgfyci6us as IPlatformUserProvider,
} from './Shared7Punches-domain-user-domain.mjs';
import {
  Clientssjxb7gh2u6y as Client,
  ApiVersion_APRIL_2026_getInstance1y3s521mv7m63 as ApiVersion_APRIL_2026_getInstance,
} from './Shared7Punches-infrastructure-network.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
import { IFeatureFlagEvaluatorscidb4c0cp4 as IFeatureFlagEvaluator } from './Shared7Punches-infrastructure-featureflag.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(UserRepository, 'UserRepository', VOID, VOID, [IUserAccessor]);
initMetadataForInterface(IUserRemoteSource, 'IUserRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForCompanion(Companion);
initMetadataForClass(UserRemoteSource, 'UserRemoteSource', VOID, VOID, [IUserRemoteSource], [1, 0]);
//endregion
function get_userModule() {
  _init_properties_UserModule_kt__312q9j();
  return userModule;
}
var userModule;
function userModule$lambda($this$module) {
  _init_properties_UserModule_kt__312q9j();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = userModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IUserRemoteSource), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = userModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(UserRepository), null, definition_0, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  var tmp = new KoinDefinition($this$module, factory_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [getKClass(IUserAccessor)];
  binds(tmp, tmp$ret$8);
  return Unit_instance;
}
function userModule$lambda$lambda($this$single, it) {
  _init_properties_UserModule_kt__312q9j();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  return new UserRemoteSource(tmp, tmp$ret$1);
}
function userModule$lambda$lambda_0($this$single, it) {
  _init_properties_UserModule_kt__312q9j();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IUserRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(IPlatformUserProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$single.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  return new UserRepository(tmp, tmp_0, tmp$ret$2);
}
var properties_initialized_UserModule_kt_h3dzll;
function _init_properties_UserModule_kt__312q9j() {
  if (!properties_initialized_UserModule_kt_h3dzll) {
    properties_initialized_UserModule_kt_h3dzll = true;
    userModule = module_0(VOID, userModule$lambda);
  }
}
function UserRepository(remoteSource, platformUserProvider, featureFlagEvaluator) {
  this.o9v_1 = remoteSource;
  this.p9v_1 = platformUserProvider;
  this.q9v_1 = featureFlagEvaluator;
}
function IUserRemoteSource() {
}
function Companion() {
  Companion_instance = this;
  this.r9v_1 = ApiVersion_APRIL_2026_getInstance();
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function UserRemoteSource(api, sessionDataProvider) {
  Companion_getInstance_0();
  this.s9v_1 = api;
  this.t9v_1 = sessionDataProvider;
}
//region block: exports
export {
  get_userModule as get_userModuleqonq4jzpfas2,
};
//endregion

